export default {
	title: "Opciones de Atención",
	subtitle: "Configurar quejas y recursos para este tipo de atención",
	label: "Nombre",
	categories: {
		COMPLAINT: "Queja",
		RESOURCE: "Recurso",
	},
	fieldTypes: {
		CHECKBOX: "Marcar",
		CHECKBOX_WITH_TEXT: "Marcar con texto",
		QUANTITY: "Cantidad",
	},
	form: {
		label: {
			label: "Nombre de la Opción",
			placeholder: "Ej: Problema respiratorio, Velas",
			hint: "Nombre que aparecerá en la ficha",
		},
		category: {
			label: "Categoría",
			hint: "Queja: lo que será tratado. Recurso: lo que será utilizado.",
		},
		fieldType: {
			label: "Tipo de Campo",
			hint: "Cómo el asistente completará esta opción en la ficha",
		},
	},
	create: "Agregar Opción",
	edit: "Editar Opción",
	delete: "Eliminar Opción",
	deleteConfirmation: "¿Desea realmente eliminar la opción \"{label}\"?",
	messages: {
		created: "Opción \"{label}\" creada con éxito",
		updated: "Opción \"{label}\" actualizada con éxito",
		deleted: "Opción \"{label}\" eliminada con éxito",
		loadError: "Error al cargar opciones",
		createError: "Error al crear opción",
		updateError: "Error al actualizar opción",
		deleteError: "Error al eliminar opción",
	},
	empty: {
		title: "Ninguna opción configurada",
		text: "Agregue quejas y recursos que podrán ser seleccionados al emitir fichas de este tipo de atención",
	},
	tabs: {
		complaints: "Quejas",
		resources: "Recursos",
	},
	ticket: {
		sectionTitle: "Opciones de Atención",
		complaints: "Quejas",
		resources: "Recursos",
		customTextPlaceholder: "Describa...",
		quantityLabel: "Cant",
		topComplaint: "Queja principal",
	},
	validation: {
		labelRequired: "Nombre es obligatorio",
		categoryRequired: "Categoría es obligatoria",
	},
};
